import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {GroupResourceOption} from '../../../graphql/groups.datatypes';
import {gqlGroupOption} from '../getGroupMember.api';

export interface UpdateGroupResourceOptionInput {
    data: {
        id: number
        group_id?: number
        resource_option_id?: number
        mandatory?: boolean
        editing_level?: number
        view_level?: number
        unit_cost_override?: number | null
        action_type_override?: number | null
        hidden_override?: boolean | null
        additional_charge_override?: boolean | null
    }
}

interface UpdateGroupResourceOptionData {
  updateGroupResourceOption: GroupResourceOption,
}

export const UPDATE_GROUP_RESOURCE_OPTION_MUTATION = gql`
  mutation updateGroupResourceOption($data: UpdateGroupResourceOptionInput!){
    updateGroupResourceOption(data: $data) {
      ${gqlGroupOption}
    }
  }
`;

export const updateGroupResourceOption = () => {
  return useMutation<UpdateGroupResourceOptionData, UpdateGroupResourceOptionInput>(
    UPDATE_GROUP_RESOURCE_OPTION_MUTATION,
    {
      update: updateCacheByType('GroupResourceOption'),
    }
  );
};

export default updateGroupResourceOption;